import { BooleanCons, NumberCons, StringConst } from 'src/app/constants/const';
export class AutorizeOrder {
    transaction: string;
    needAuthorized: boolean;
    cardCode: string;
    specialityDoctor: string;
    priceListId: number;
    constructor() {
        this.transaction = StringConst.empty;
        this.needAuthorized = BooleanCons.true;
        this.cardCode = StringConst.empty;
        this.specialityDoctor = StringConst.empty;
        this.priceListId = NumberCons.one;
    }
}
